import { eventBus } from '@/modules/common/eventBus';
import { NotifyData } from '@/types';

const notify = (obj: NotifyData) => {
    return eventBus.$emit('NOTIFY', obj);
};

export default notify;
